import React from 'react';
import { Typography, Grid } from '@material-ui/core'
import './main.css';
import waves from '../images/WAVES.png';
import demo from '../Ziplyne-for-workday/images/ZL ontop of WD 2 .webm';
import AppearingElement from "../Helper/AppearingElement";

function Slide() {
    return (
        <div className="slide-app" >
            <img src={waves} alt="" className="slide__waves-app" />
            <Grid container
                spacing={1}
                direction="row"
                justify="space-around"
                alignItems="flex-start">
                <Grid item xs={8} sm={8} md={6}>
                    <video src={demo} className="slide__video-app" autoPlay loop muted playsInline />
                </Grid>
                <Grid item xs={12} sm={12} md={6} >
                    <div className="slide__container-app">
                        <AppearingElement variant="zoom-down">
                            <Typography className="slide__main-text-app" variant="h3" >Rethink Your Constituent/Employee Experience!</Typography>
                        </AppearingElement>
                        <AppearingElement variant="zoom-down">
                            <Typography className="slide__sub-text-app" variant="subtitle1" >Ziplyne enables your end users and employees to navigate your site/applications to their fullest without the need to rely on your support centers, in-person help, or other internal resources.</Typography>
                        </AppearingElement>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default Slide